import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput} from './ObjectTypePicker.style';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {DropdownOptionProps, DropdownSingleValueProps} from '../../models/DropdownProps';

export const ObjectTypePicker: React.VFC<DropdownSingleValueProps<string>> = (props) => {
    const [objectTypeInput, setObjectTypeInput] = useState<string>(props.defaultValue ? props.defaultValue.toLowerCase() : '');
    const [objectTypeOptions, setObjectTypeOptions] = useState<DropdownOptionProps[]>(props.dataSource);

    const setState = (selectionState: string, selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        props.onChange(selectionState);
        setObjectTypeOptions(selectionOptions);
        if (resetInput) {
            setObjectTypeInput('');
        }
    };

    useEffect(() => {
        setObjectTypeOptions(props.dataSource);
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState('', props.dataSource, true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setObjectTypeInput(eventValue);
        let selectionOptions = objectTypeOptions;
        if (props.resetInput) {
            selectionOptions = objectTypeOptions.filter(type => (type.name !== eventValue));
        }
        setState(eventValue, selectionOptions, props.resetInput);
    };

    return (
        <Accordion localizedHeadline={t('OBJECT_TYPE_PICKER_CAPTION')}>
            <DropdownInput id={generateIdentifier('objectType_'.concat(objectTypeInput))}
                           name={'objectTypeName_'.concat(objectTypeInput)}
                           aria-label={'objectType_'.concat(objectTypeInput)}
                           defaultValue={props.defaultValue ? props.defaultValue.toLowerCase() : ''}
                           value={objectTypeInput}
                           options={objectTypeOptions}
                           disabled={props.disabled}
                           onChange={handleInput}/>
        </Accordion>
    );
};
